module.exports = __webpack_public_path__ + "img/bai.17457959.png";